module.exports = __webpack_public_path__ + "static/media/mango.de12584b.jpg";